import { useExperiments } from '@wix/fe-essentials-standalone';
import { useRouter } from 'next/router';
import { EXPERIMENTS, KA_SEARCH_EXPANDED_LOCALES, LOCALES } from '../constants';

export const useIsKnowledgeAgentSearchEnabled = () => {
  const { locale } = useRouter();
  const { experiments } = useExperiments({ readOnly: true });

  if (LOCALES.EN === locale) {
    return true;
  }

  return experiments.enabled(EXPERIMENTS.SPECS.KA_SEARCH_EXPANDED_LOCALES)
    && KA_SEARCH_EXPANDED_LOCALES.includes(locale as string);
};
